
import { action, observable } from 'mobx';
import {
	Model,
	IModelAttributes,
	attribute,
	entity,
	ReferencePath,
} from 'Models/Model';
import * as Validators from 'Validators';
import { CRUD } from '../CRUDOptions';
import * as AttrUtils from 'Util/AttributeUtils';
import { IAcl } from 'Models/Security/IAcl';
import {
	getCreatedModifiedCrudOptions,
} from 'Util/EntityUtils';
import UserActiveUserPricingTierEntity from 'Models/Security/Acl/UserActiveUserPricingTierEntity';
import VisitorsActiveUserPricingTierEntity from 'Models/Security/Acl/VisitorsActiveUserPricingTierEntity';
import { EntityFormMode } from 'Views/Components/Helpers/Common';
import SuperAdministratorScheme from '../Security/Acl/SuperAdministratorScheme';

import { store } from 'Models/Store';
import { gql } from '@apollo/client';
import { computed, runInAction } from 'mobx';

export interface IActiveUserPricingTierEntityAttributes extends IModelAttributes {
	maximumUsers: number;
	price: number;


}

@entity('ActiveUserPricingTierEntity', 'Active User Pricing Tier')
export default class ActiveUserPricingTierEntity extends Model
	implements IActiveUserPricingTierEntityAttributes {
	public static acls: IAcl[] = [
		new SuperAdministratorScheme(),
		new UserActiveUserPricingTierEntity(),
		new VisitorsActiveUserPricingTierEntity(),

	];

	/**
	 * Fields to exclude from the JSON serialization in create operations.
	 */
	public static excludeFromCreate: string[] = [];

	/**
	 * Fields to exclude from the JSON serialization in update operations.
	 */
	public static excludeFromUpdate: string[] = [];

	
	@Validators.Integer()
	@observable
	@attribute<ActiveUserPricingTierEntity, number>()
	@CRUD({
		name: 'Maximum Users',
		displayType: 'textfield',
		order: 10,
		headerColumn: true,
		searchable: true,
		searchFunction: 'equal',
		searchTransform: AttrUtils.standardiseInteger,
	})
	public maximumUsers: number;
	

	
	/**
	 * Price
	 */
	@Validators.Integer()
	@observable
	@attribute<ActiveUserPricingTierEntity, number>()
	@CRUD({
		name: 'Price',
		displayType: 'textfield',
		order: 20,
		headerColumn: true,
		searchable: true,
		searchFunction: 'equal',
		searchTransform: AttrUtils.standardiseInteger,
	})
	public price: number;


	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(attributes?: Partial<IActiveUserPricingTierEntityAttributes>) {
		super(attributes);
	}

	/**
	 * Assigns fields from a passed in JSON object to the fields in this model.
	 * Any reference objects that are passed in are converted to models if they are not already.
	 * This function is called from the constructor to assign the initial fields.
	 */
	@action
	public assignAttributes(attributes?: Partial<IActiveUserPricingTierEntityAttributes>) {
		super.assignAttributes(attributes);

		if (attributes) {
			if (attributes.maximumUsers !== undefined) {
				this.maximumUsers = attributes.maximumUsers;
			}
			if (attributes.price !== undefined) {
				this.price = attributes.price;
			}

		}
	}

	/**
	 * Additional fields that are added to GraphQL queries when using the
	 * the managed model APIs.
	 */
	public defaultExpands = `
	`;

	/**
	 * The save method that is called from the admin CRUD components.
	 */
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	public async saveFromCrud(formMode: EntityFormMode) {
		const relationPath: ReferencePath = {
		};
		return this.save(
			relationPath,
			{
				options: [
					{
						key: 'mergeReferences',
						graphQlType: '[String]',
						value: [
						],
					},
				],
			},
		);
	}

	/**
	 * Returns the string representation of this entity to display on the UI.
	 */
	public getDisplayName() {
		return this.id;
	}
}

/*
 * Retrieve the created and modified CRUD attributes for defining the CRUD views and decorate the class with them.
 */
const [createdAttr, modifiedAttr] = getCreatedModifiedCrudOptions();
CRUD(createdAttr)(ActiveUserPricingTierEntity.prototype, 'created');
CRUD(modifiedAttr)(ActiveUserPricingTierEntity.prototype, 'modified');
